import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportRoutinglogInspectorComponent } from './component/transport-routinglog-inspector.component';
import { DictionaryModule, CommonUIModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonTranslationModule } from '@sdbn/common';

import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';

import { MatInputModule as MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    TransportRoutinglogInspectorComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    FormsModule,
    ReactiveFormsModule,

    CommonTranslationModule,
    CommonUIModule,
    MatFormFieldModule,
    MatInputModule
]
})
export class TransportRoutinglogInspectorModule { }
